import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CloseIcon from "../assets/img/close-icon.svg";

import { toast } from "react-toastify";
import { useLocalization } from "./Localization/Localization";
import { GetValueLableWithId } from "../utils/Helper";
import Select from "react-select";

function SelectSchoolModal(props) {
  const { t } = useLocalization();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (props?.schoolList) {
      setOptions(GetValueLableWithId(props?.schoolList, ["_id", "name"]));
    }
  }, [props?.schoolList]);

  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Body>
          <div className="edit-profile">
            <h2>{t("select_school")}</h2>
            {/* <select
              className="form-control mt-1 w-100"
              onChange={(e) => {
                localStorage.setItem("school", e.target.value);
                props.close();
              }}
              value={localStorage.getItem("school")}
            >
               <option selected value="" disabled>
                --{t("select_school")}--
              </option>
              {props?.schoolList?.schoolStaff &&
                props?.schoolList?.schoolStaff?.map((val, i) => (
                  <option value={val?.school?._id}>{val?.school?.name}</option>
                ))}
            </select> */}
            <Select
              options={options}
              onChange={(option) => {
                localStorage.setItem("school", option.value);
                props.close();
              }}
              // value={options.find((option) => option.value === schoolId)}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SelectSchoolModal;
